import { API_CATEGORY_ASSISTANT } from "@/apis/api-endpoint";
import Fetch from "@/helpers/fetch";
class CategoryAssistant {
    async getCategoryAssistant() {
        const result = await Fetch.make().get(API_CATEGORY_ASSISTANT, {authHeader: true})
        return result
    }
}

export default new CategoryAssistant();